/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { TypedEventEmitter } from "@fluid-internal/client-utils";
/**
 * This abstract class implements IDocumentService interface. It uses delegation pattern.
 * It delegates all calls to IDocumentService implementation passed to constructor.
 */
export class DocumentServiceProxy extends TypedEventEmitter {
    constructor(_service) {
        super();
        this._service = _service;
    }
    get service() {
        return this._service;
    }
    async connectToStorage() {
        return this._service.connectToStorage();
    }
    async connectToDeltaStorage() {
        return this._service.connectToDeltaStorage();
    }
    async connectToDeltaStream(client) {
        return this._service.connectToDeltaStream(client);
    }
    dispose(error) {
        this._service.dispose(error);
    }
    get resolvedUrl() {
        return this._service.resolvedUrl;
    }
}
//# sourceMappingURL=documentServiceProxy.js.map